export default "__VITE_ASSET__68758a14__"